type Handler = (payload: any) => void

const handlers: Record<string, Handler[]> = {}
let es: EventSource | null = null
let retryDelay = 2000
let connected = false

export function on(type: string, handler: Handler) {
  handlers[type] = handlers[type] || []
  handlers[type].push(handler)
}

export function startEvents() {
  if (es) return
  const base = (import.meta.env.DEV ? '' : (import.meta.env.VITE_API_URL?.replace(/\/api$/, '') || ''))
  es = new EventSource(`${base}/api/events/stream`)
  es.onopen = () => {
    connected = true
    retryDelay = 2000
    const list = handlers['sse_status'] || []
    list.forEach(h => h({ connected: true }))
    if (import.meta.env.DEV) console.debug('[SSE] connected')
  }
  es.addEventListener('message', (e) => {
    try {
      const data = JSON.parse((e as MessageEvent).data)
      const list = handlers[data.type] || []
      list.forEach(h => h(data.payload))
    } catch {}
  })
  es.onerror = () => {
    try { es && es.close() } catch {}
    es = null
    if (connected) {
      connected = false
      const list = handlers['sse_status'] || []
      list.forEach(h => h({ connected: false }))
      if (import.meta.env.DEV) console.warn('[SSE] disconnected, will retry...')
    }
    // 退避重连
    setTimeout(() => {
      retryDelay = Math.min(retryDelay * 2, 30000)
      startEvents()
    }, retryDelay)
  }
}

export function isSseConnected() { return connected }


